import Box from '@mui/material/Box';
import { Theme, useTheme } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import TabsX from '@mui/material/Tabs';
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router';
import SwipeableViews from 'react-swipeable-views';

interface TabPanelProps {
  children?: React.ReactNode;
  value: number;
  index: number;
  dir?: string;
  sx?: object; // optional sx prop for custom styling
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
    sx: { textTransform: 'none', fontSize: '1.4rem' }
  };
}

interface TabsProps {
  tabHeaders: string[]; // An array of tab headers (strings)
  tabsContent: React.ReactNode[]; // An array of tab content (React nodes or JSX elements)
}

export default function Tabs({ tabHeaders, tabsContent }: TabsProps) {
  const theme = useTheme<Theme>();
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = React.useState<number>(0);

  React.useEffect(() => {
    if (location.pathname === '/faq') {
      setValue(1);
    } else {
      setValue(0);
    }
  }, [location.pathname]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (newValue === 1) {
      navigate(`/faq${window.location.search}`);
    } else {
      navigate(`/instructions${window.location.search}`);
    }
    setValue(newValue);
  };

  const handleChangeIndex = (index: number) => {
    if (index === 1) {
      navigate(`/faq${window.location.search}`);
    } else {
      navigate(`/instructions${window.location.search}`);
    }
    setValue(index);
  };

  return (
    <Box sx={{ bgcolor: 'background.paper', width: '100%' }}>
      <TabsX
        value={value}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        variant="fullWidth">
        {tabHeaders?.map((tabHeader: string, i: number) => (
          <Tab label={tabHeader} key={tabHeader} {...a11yProps(i)} />
        ))}
      </TabsX>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}>
        {tabsContent?.map((tab: React.ReactNode, i: number) => (
          <TabPanel
            key={`tab-${i}`}
            value={value}
            index={i}
            dir={theme.direction}
            sx={{
              width: '90%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
            {tab}
          </TabPanel>
        ))}
      </SwipeableViews>
    </Box>
  );
}
